import React from 'react'
import Breadcrumb from '../common/Breadcrumb'
import { Link } from 'react-router-dom'

const TransferCertificate = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Transfer Certificate"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Transfer Certificate" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mx-auto">            
            <h1 class="main-title">Transfer Certificate</h1>
            <div className="curved-line mx-auto mt-3"></div>
            <ul class="download-list">
                <li><Link to={'/images/TC.pdf'} target='blank' class="download-link" data-version="Latest">Download TC</Link></li>
                {/* <li><Link to={'#'} class="download-link" data-version="Stable">Download TC 5</Link></li>
                <li><Link to={'#'} class="download-link" data-version="Legacy">Download TC 4</Link></li>
                <li><Link to={'#'} class="download-link" data-version="Legacy">Download TC 3</Link></li>
                <li><Link to={'#'} class="download-link" data-version="Archive">Download TC 2</Link></li>
                <li><Link to={'#'} class="download-link" data-version="Archive">Download TC 1</Link></li> */}
            </ul>         
          </div>          
        </div>
      </div>
    </section>
    </>
  )
}

export default TransferCertificate
